var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAcalaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.62 101.24c27.956 0 50.62-22.664 50.62-50.62C101.24 22.664 78.576 0 50.62 0 22.664 0 0 22.664 0 50.62c0 27.956 22.664 50.62 50.62 50.62Zm.206-4.75c25.333 0 45.867-20.537 45.867-45.868 0-25.33-20.534-45.869-45.867-45.869C25.494 4.753 4.96 25.287 4.96 50.62s20.534 45.87 45.866 45.87Zm-.206-3.514c23.393 0 42.355-18.963 42.355-42.356S74.013 8.265 50.62 8.265c-23.393 0-42.355 18.962-42.355 42.355 0 23.393 18.962 42.355 42.355 42.355Zm.104-5.164c20.596 0 37.294-16.698 37.294-37.294 0-20.596-16.698-37.294-37.294-37.294-20.596 0-37.293 16.696-37.293 37.294 0 20.598 16.695 37.294 37.293 37.294Zm-.313-30.314c-2.073 0-4.086.173-6.035.503l3-5.211a44.838 44.838 0 0 1 10.107.468l-11.652-20.24-19.4 33.692-2.772-4.815 22.127-38.431.045.079.043-.077 26.705 46.38h-5.544l-6.242-10.84c-3.252-.983-6.728-1.508-10.382-1.508Zm23.894 9.292L48.45 21.888h5.544l23.082 40.088-2.771 4.814Zm-25.66-22.749L38.03 62.48c3.798-1.15 8.27-1.662 12.488-1.662a44.832 44.832 0 0 1 8.162.758l3.542 6.151c-3.625-1.322-7.55-2.101-11.704-2.101-6.145 0-11.788 1.524-16.703 4.174l.079-.14-.107.185h-5.544l17.631-30.62 2.77 4.817Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.802 55.648h9.281l-4.664-13.523-4.617 13.523Zm12.93 11.209-2.066-5.995h-12.493l-2.067 5.995h-7.102l11.539-32.583h7.8l11.491 32.583h-7.102Z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.621 63.353c-2.336-2.387-3.504-5.556-3.502-9.506.002-3.95 1.169-7.118 3.502-9.504 2.334-2.39 5.359-3.586 9.077-3.584 3.103 0 5.699.751 7.79 2.252 2.091 1.502 3.486 3.629 4.185 6.381h-6.997c-.828-2.11-2.485-3.167-4.97-3.167-1.873 0-3.339.681-4.4 2.044-1.06 1.362-1.59 3.222-1.59 5.578 0 2.36.53 4.22 1.59 5.581 1.061 1.36 2.525 2.038 4.392 2.03 2.459 0 4.116-1.07 4.97-3.213h7.005a11.446 11.446 0 0 1-4.255 6.342c-2.103 1.564-4.677 2.346-7.72 2.346-3.716 0-6.742-1.194-9.077-3.58Z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.407 59.477c1.369-1.346 2.053-3.197 2.053-5.552 0-2.354-.684-4.206-2.053-5.554a6.711 6.711 0 0 0-4.787-2.02 6.726 6.726 0 0 0-4.797 1.996c-1.352 1.335-2.028 3.179-2.028 5.531 0 2.353.684 4.213 2.051 5.579a6.621 6.621 0 0 0 4.776 2.043 6.643 6.643 0 0 0 4.785-2.023Zm-14.963 4.004c-2.321-2.499-3.48-5.69-3.479-9.574.002-3.884 1.154-7.059 3.456-9.525 2.303-2.469 5.23-3.704 8.781-3.704s6.26 1.46 8.127 4.38V41.05h6.54v25.806h-6.54v-4.332c-1.963 3.138-4.689 4.706-8.177 4.705-3.487-.002-6.39-1.252-8.708-3.749Z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.978 67.118h6.54V34.535h-6.54v32.583Z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.447 59.373c1.369-1.346 2.052-3.197 2.049-5.552 0-2.354-.683-4.206-2.049-5.555a6.695 6.695 0 0 0-2.191-1.493 6.735 6.735 0 0 0-5.199-.013 6.746 6.746 0 0 0-2.196 1.483c-1.35 1.331-2.027 3.175-2.03 5.531 0 2.357.683 4.216 2.051 5.578a6.64 6.64 0 0 0 7.377 1.523 6.622 6.622 0 0 0 2.186-1.5l.002-.002Zm-14.872 3.845c-2.319-2.497-3.479-5.69-3.481-9.58-.002-3.889 1.151-7.064 3.457-9.527 2.305-2.469 5.231-3.704 8.782-3.704 3.552 0 6.259 1.46 8.129 4.38V40.79H256v25.805h-6.538v-4.33c-1.965 3.129-4.688 4.693-8.176 4.693-3.488 0-6.391-1.246-8.711-3.738v-.003Z",
    fill: "url(#f)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 79.763,
    y1: 95.276,
    x2: 20.569,
    y2: 4.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#645AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E40C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 271.906,
    y1: 71.418,
    x2: 250.105,
    y2: -1.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#645AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E40C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 271.906,
    y1: 71.418,
    x2: 250.105,
    y2: -1.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#645AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E40C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 271.906,
    y1: 71.418,
    x2: 250.105,
    y2: -1.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#645AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E40C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 271.906,
    y1: 71.418,
    x2: 250.105,
    y2: -1.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#645AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E40C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 271.906,
    y1: 71.418,
    x2: 250.105,
    y2: -1.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#645AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E40C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4C3B"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcalaLogo);
export default __webpack_public_path__ + "static/media/acala-logo.353a5241.svg";
export { ForwardRef as ReactComponent };